<template>
  <ODataTable class="dense-table" :spec="spec" :items="filteredRows" />
</template>

<script>
import { crayon } from 'oderon-vue/utils'

function mergeCardsAndDrivers(originJson) {
  let result = []
  if (originJson.drivers) {
    originJson.drivers.forEach((d, i) => {
      d.index = i
      result.push(d)
    })
  }

  if (originJson.cards) {
    originJson.cards.forEach((c, i) => {
      c.index = i
      result.push(c)
    })
  }

  return result
}

export default {
  components: {
    ODataTable: require('oderon-vue/cpts/ODataTable').default
  },
  props: {
    keywords: {},
    originJson: { required: true }
  },
  data() {
    return {
      spec: [
        { t: 'Pos.|', d: 'index', f: crayon.grey, w:50 },
        { t: 'ID|', d: 'id', w: 50 },
        { t: 'Nome', d: 'name' },
        { t: 'Crachá', d: 'code' },
        { t: 'Perfil', d: 'role' },
        { t: 'Expira', d: 'expiresAt' }
      ]
    }
  },
  computed: {
    filteredRows() {
      let rows = mergeCardsAndDrivers(this.originJson)
      if (this.keywords == null) return rows

      return rows.filter(row => {
        return JSON.stringify(row)
          .toLowerCase()
          .includes(this.keywords.toLowerCase())
      })
    }
  }
}
</script>

<style></style>
